// extracted by mini-css-extract-plugin
export default {"cls1":"Itt8rIpiEBFQe4yX_uOg","cls2":"xi9Q6vSh8de4fPsYFrxA Itt8rIpiEBFQe4yX_uOg"};